(function () {
  "use strict";

  var config = window.autoLocalization;
  var storageKey = "neulooms:auto-localization-country";
  var rateStorageKey = "neulooms:auto-currency-rates";
  var sourceCurrency = "INR";
  var priceSelector = [
    ".bls__product-price .price",
    ".bls__product-price .price-item",
    ".bls__total-price .price",
    ".bls__total-price .price-item",
    ".saved-price .price",
    ".bls-minicart-item-price",
    ".bls-minicart-item-original-price",
    ".bls-subtotal-price",
    "[data-cart-subtotal-price]",
    ".cart-item__final-price",
    ".cart-item__old-price",
    ".cart-item__price-wrapper .price",
    ".cart-item__price-wrapper .product-option",
    ".filter-price .price",
    ".price-lable .price",
    ".cs__card-price"
  ].join(",");

  var countryCurrencies = {
    AC: "SHP", AD: "EUR", AE: "AED", AF: "AFN", AG: "XCD", AI: "XCD", AL: "ALL", AM: "AMD",
    AO: "AOA", AR: "ARS", AS: "USD", AT: "EUR", AU: "AUD", AW: "AWG", AX: "EUR", AZ: "AZN",
    BA: "BAM", BB: "BBD", BD: "BDT", BE: "EUR", BF: "XOF", BG: "BGN", BH: "BHD", BI: "BIF",
    BJ: "XOF", BL: "EUR", BM: "BMD", BN: "BND", BO: "BOB", BQ: "USD", BR: "BRL", BS: "BSD",
    BT: "BTN", BW: "BWP", BY: "BYN", BZ: "BZD", CA: "CAD", CC: "AUD", CD: "CDF", CF: "XAF",
    CG: "XAF", CH: "CHF", CI: "XOF", CK: "NZD", CL: "CLP", CM: "XAF", CN: "CNY", CO: "COP",
    CR: "CRC", CV: "CVE", CW: "ANG", CX: "AUD", CY: "EUR", CZ: "CZK", DE: "EUR", DJ: "DJF",
    DK: "DKK", DM: "XCD", DO: "DOP", DZ: "DZD", EC: "USD", EE: "EUR", EG: "EGP", EH: "MAD",
    ER: "ERN", ES: "EUR", ET: "ETB", FI: "EUR", FJ: "FJD", FK: "FKP", FO: "DKK", FR: "EUR",
    GA: "XAF", GB: "GBP", GD: "XCD", GE: "GEL", GF: "EUR", GG: "GBP", GH: "GHS", GI: "GIP",
    GL: "DKK", GM: "GMD", GN: "GNF", GP: "EUR", GQ: "XAF", GR: "EUR", GS: "GBP", GT: "GTQ",
    GU: "USD", GW: "XOF", GY: "GYD", HK: "HKD", HN: "HNL", HR: "EUR", HT: "HTG", HU: "HUF",
    ID: "IDR", IE: "EUR", IL: "ILS", IM: "GBP", IN: "INR", IO: "USD", IQ: "IQD", IR: "IRR",
    IS: "ISK", IT: "EUR", JE: "GBP", JM: "JMD", JO: "JOD", JP: "JPY", KE: "KES", KG: "KGS",
    KH: "KHR", KI: "AUD", KM: "KMF", KN: "XCD", KR: "KRW", KW: "KWD", KY: "KYD", KZ: "KZT",
    LA: "LAK", LB: "LBP", LC: "XCD", LI: "CHF", LK: "LKR", LR: "LRD", LS: "LSL", LT: "EUR",
    LU: "EUR", LV: "EUR", LY: "LYD", MA: "MAD", MC: "EUR", MD: "MDL", ME: "EUR", MF: "EUR",
    MG: "MGA", MK: "MKD", ML: "XOF", MM: "MMK", MN: "MNT", MO: "MOP", MP: "USD", MQ: "EUR",
    MR: "MRU", MS: "XCD", MT: "EUR", MU: "MUR", MV: "MVR", MW: "MWK", MX: "MXN", MY: "MYR",
    MZ: "MZN", NA: "NAD", NC: "XPF", NE: "XOF", NF: "AUD", NG: "NGN", NI: "NIO", NL: "EUR",
    NO: "NOK", NP: "NPR", NR: "AUD", NU: "NZD", NZ: "NZD", OM: "OMR", PA: "PAB", PE: "PEN",
    PF: "XPF", PG: "PGK", PH: "PHP", PK: "PKR", PL: "PLN", PM: "EUR", PN: "NZD", PR: "USD",
    PS: "ILS", PT: "EUR", PW: "USD", PY: "PYG", QA: "QAR", RE: "EUR", RO: "RON", RS: "RSD",
    RU: "RUB", RW: "RWF", SA: "SAR", SB: "SBD", SC: "SCR", SD: "SDG", SE: "SEK", SG: "SGD",
    SH: "SHP", SI: "EUR", SJ: "NOK", SK: "EUR", SL: "SLL", SM: "EUR", SN: "XOF", SO: "SOS",
    SR: "SRD", SS: "SSP", ST: "STN", SV: "USD", SX: "ANG", SY: "SYP", SZ: "SZL", TA: "SHP",
    TC: "USD", TD: "XAF", TF: "EUR", TG: "XOF", TH: "THB", TJ: "TJS", TK: "NZD", TL: "USD",
    TM: "TMT", TN: "TND", TO: "TOP", TR: "TRY", TT: "TTD", TV: "AUD", TW: "TWD", TZ: "TZS",
    UA: "UAH", UG: "UGX", US: "USD", UY: "UYU", UZ: "UZS", VA: "EUR", VC: "XCD", VE: "VES",
    VG: "USD", VI: "USD", VN: "VND", VU: "VUV", WF: "XPF", WS: "WST", XK: "EUR", YE: "YER",
    YT: "EUR", ZA: "ZAR", ZM: "ZMW", ZW: "USD"
  };

  if (!config || !config.currentCountry || !Array.isArray(config.availableCountries)) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var currentCountry = normalizeCountry(config.currentCountry);
  var availableCountries = config.availableCountries.map(normalizeCountry).filter(Boolean);

  if (!currentCountry || availableCountries.length < 2) return;

  updateCountrySelectorLabels();
  detectCountry().then(function (detectedCountry) {
    var country = detectedCountry || currentCountry;
    var currency = countryCurrencies[country] || sourceCurrency;

    if (detectedCountry && detectedCountry !== currentCountry && availableCountries.indexOf(detectedCountry) !== -1) {
      submitCountryOnce(detectedCountry);
    }

    if (currency !== sourceCurrency) {
      convertPrices(currency);
    }
  });

  function detectCountry() {
    var rootUrl = config.rootUrl || "/";
    var suggestionUrl =
      rootUrl +
      "browsing_context_suggestions.json?country[enabled]=true&country[exclude]=" +
      encodeURIComponent(currentCountry);

    return fetch(suggestionUrl, { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("Unable to load localization suggestions.");
        return response.json();
      })
      .then(function (data) {
        return getSuggestedCountry(data);
      })
      .catch(function () {
        return currentCountry;
      });
  }

  function getSuggestedCountry(data) {
    var suggestion = data && data.suggestions && data.suggestions[0];
    var country =
      suggestion &&
      suggestion.parts &&
      suggestion.parts.country &&
      suggestion.parts.country.handle;

    if (!country && data && data.detected_values && data.detected_values.country) {
      country = data.detected_values.country.handle;
    }

    return normalizeCountry(country);
  }

  function submitCountryOnce(country) {
    var form = document.querySelector(config.formSelector || "#AutoLocalizationForm");
    var countryInput = form && form.querySelector('input[name="country_code"]');
    var returnToInput = form && form.querySelector('input[name="return_to"]');

    if (!form || !countryInput) return;
    if (readStoredCountry() === country) return;

    writeStoredCountry(country);
    countryInput.value = country;

    if (returnToInput) {
      returnToInput.value = window.location.pathname + window.location.search;
    }

    form.submit();
  }

  function convertPrices(currency) {
    loadRate(currency).then(function (rate) {
      if (!rate) return;
      rewritePrices(rate, currency);
      observePriceChanges(rate, currency);
    });
  }

  function loadRate(currency) {
    var cached = readCachedRates();

    if (cached && cached.rates && cached.rates[currency] && Date.now() - cached.timestamp < 21600000) {
      return Promise.resolve(Number(cached.rates[currency]));
    }

    return fetch("https://open.er-api.com/v6/latest/" + sourceCurrency)
      .then(function (response) {
        if (!response.ok) throw new Error("Unable to load currency rates.");
        return response.json();
      })
      .then(function (data) {
        if (!data || !data.rates) return null;
        writeCachedRates(data.rates);
        return Number(data.rates[currency] || 0);
      })
      .catch(function () {
        return null;
      });
  }

  function rewritePrices(rate, currency) {
    document.querySelectorAll(priceSelector).forEach(function (element) {
      rewritePriceElement(element, rate, currency);
    });
  }

  function rewritePriceElement(element, rate, currency) {
    var text = element.textContent;
    var sourceText = text;

    if (!text || !text.trim()) return;
    if (element.dataset.autoCurrencyRendered === text && element.dataset.autoCurrencySource) {
      sourceText = element.dataset.autoCurrencySource;
    }

    if (sourceText.indexOf(currency) !== -1) return;

    var converted = sourceText.replace(/(?:INR|Rs\.?|₹)?\s*(\d[\d,]*(?:\.\d{1,2})?)/g, function (match, amount) {
      var value = Number(amount.replace(/,/g, ""));

      if (!Number.isFinite(value)) return match;
      return formatMoney(value * rate, currency);
    });

    if (converted === sourceText) return;

    element.dataset.autoCurrencySource = sourceText;
    element.dataset.autoCurrencyRendered = converted;
    element.textContent = converted;
  }

  function observePriceChanges(rate, currency) {
    var observer = new MutationObserver(function (mutations) {
      var shouldRewrite = mutations.some(function (mutation) {
        return mutation.type === "childList" || mutation.type === "characterData";
      });

      if (shouldRewrite) {
        window.requestAnimationFrame(function () {
          rewritePrices(rate, currency);
        });
      }
    });

    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  function updateCountrySelectorLabels() {
    document.querySelectorAll("localization-form a[data-value]").forEach(function (link) {
      var country = normalizeCountry(link.dataset.value);
      var currency = countryCurrencies[country];

      if (!currency) return;

      var mobileCurrency = link.querySelector(".img-country + span");
      if (mobileCurrency) {
        mobileCurrency.textContent = currency;
        return;
      }

      var name = link.textContent.replace(/\([^)]*\)/g, "").trim();
      link.textContent = name + " (" + currency + " " + getCurrencySymbol(currency) + ")";
    });

    document.querySelectorAll("localization-form .button-localization").forEach(function (button) {
      var form = button.closest("localization-form");
      var input = form && form.querySelector('input[name="country_code"]');
      var country = input ? normalizeCountry(input.value) : currentCountry;
      var currency = countryCurrencies[country];
      var icon = button.querySelector("i");
      var name = button.textContent.replace(/\([^)]*\)/g, "").trim();

      if (!currency) return;

      button.textContent = name + " (" + currency + " " + getCurrencySymbol(currency) + ") ";

      if (icon) {
        button.appendChild(icon);
      }
    });
  }

  function formatMoney(value, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency,
        maximumFractionDigits: zeroDecimalCurrency(currency) ? 0 : 2
      }).format(value);
    } catch (error) {
      return currency + " " + value.toFixed(2);
    }
  }

  function getCurrencySymbol(currency) {
    try {
      var parts = new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency,
        currencyDisplay: "narrowSymbol",
        maximumFractionDigits: 0
      }).formatToParts(0);
      var currencyPart = parts.find(function (part) {
        return part.type === "currency";
      });

      return currencyPart ? currencyPart.value : currency;
    } catch (error) {
      return currency;
    }
  }

  function zeroDecimalCurrency(currency) {
    return ["BIF", "CLP", "DJF", "GNF", "ISK", "JPY", "KMF", "KRW", "PYG", "RWF", "UGX", "VND", "VUV", "XAF", "XOF", "XPF"].indexOf(currency) !== -1;
  }

  function normalizeCountry(country) {
    return typeof country === "string" ? country.trim().toUpperCase() : "";
  }

  function readStoredCountry() {
    try {
      return normalizeCountry(window.localStorage.getItem(storageKey));
    } catch (error) {
      return "";
    }
  }

  function writeStoredCountry(country) {
    try {
      window.localStorage.setItem(storageKey, country);
    } catch (error) {
      return null;
    }
  }

  function readCachedRates() {
    try {
      return JSON.parse(window.localStorage.getItem(rateStorageKey));
    } catch (error) {
      return null;
    }
  }

  function writeCachedRates(rates) {
    try {
      window.localStorage.setItem(rateStorageKey, JSON.stringify({ timestamp: Date.now(), rates: rates }));
    } catch (error) {
      return null;
    }
  }
})();
